import _ from 'lodash';
import axios from 'axios';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { check } from '../../../Utils/FormCalls';
import { decode as base64_decode } from 'base-64';
import TableView from '../../../Widgets/TableView';
import FileBase64 from '../../../Utils/FileUpload';
import { constant } from '../../../Utils/constants';
import TableSelect from '../../../Widgets/TableSelect';
import React, { useEffect, useRef, useState } from 'react';
import { Form, message, Select, Input, Modal, Button, Typography } from 'antd';
import localStorage from '../../../../../utils/localStorage';
import InputComponent from '../../../Widgets/InputComponent';
import translation from '../../../../../commons/translation';

import InputNumberComponent from '../../../Widgets/InputNumberComponent';
import { PaperClipOutlined, DownOutlined, SearchOutlined } from '@ant-design/icons';
import { API_DEVICE, API_PARAMETER, API_MASTERITEMS } from '../../../../../commons/api';
import {
  StyledBox,
  StyledBoxHeader,
  StyledBoxLabel
} from '../../../CSS/style';
import {
  getSitesList,
  getLocationByAsset,
  submitMaster,
  getDeviceList,
  getManufacturerList,
  getMasterById
} from '../../../Utils/FormCalls';
import dayjs from 'dayjs';
import { StyledHomepageSides } from '../../../../../commons/styles/layout';

const { Option } = Select;
const type = 'Item';
const urlList = {
  insert: `${API_MASTERITEMS.INSERT}`,
  getbyId: `${API_MASTERITEMS.GetById}`,
  delete: `${API_MASTERITEMS.DELETE}?Id=3`
};
const fileData = new FormData();

const ItemDetails = (props) => {

  const [sitesList, setSitesList] = useState([]);
  const [formObject, setFormObject] = useState(props.formObject || {});
  const [datasource, setDatasource] = useState(props.formObject?.Specifications || []);
  // const [Attachments,setAttachments] = useState(props.Attachments||{});
  const [tableData, setTableData] = useState([]);
  const [ManufacturerList, setManufacturerList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [deviceList, setDeviceList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [columns] = useState([
    {
      title: translation(props.translationCache, constant.name),
      key: 'Name',
      dataIndex: 'Name',
      widget: 'input',
      required: true
    },
    {
      title: translation(props.translationCache, constant.value),
      key: 'Value',
      dataIndex: 'Value',
      widget: 'inputNumber',
      required: true
    },
    {
      title: translation(props.translationCache, constant.unitOfMeasure),
      key: 'UOM',
      dataIndex: 'UOM',
      widget: 'select',
      required: true,
      table: {
        url: `${API_PARAMETER.GetUOM}`,
        method: 'GET'
      }
    }
  ]);
  const searchInput = useRef(null);
  const ItemRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const sitesList = await getSitesList();
        let formObject = ItemRef.current && ItemRef.current.getFieldsValue();


        formObject = {
          ...formObject,
          SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
        };


        if (ItemRef.current) {
          ItemRef.current.setFieldsValue(formObject);
        }
        setSitesList(sitesList);
        setFormObject(formObject);
      } catch (error) {
        message.warning(`${error.message}`);
      }

      try {
        const deviceList = await getDeviceList();
        setDeviceList(deviceList);
      } catch (error) {
        message.warning(`${error.message}`);
      }

      try {
        const manufacturerList = await getManufacturerList();
        setManufacturerList(manufacturerList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }

    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }

    if (props.formObject && Object.keys(props.formObject).length === 0) {
      if (ItemRef.current) ItemRef.current.setFieldsValue(props.formObject);
    }

    if (props.formObject !== formObject) {
      setFormObject(props.formObject);
    }
    // setAttachments(props.Attachments);
  }, [props.translationCache, props.formObject]);
  const _getDataById = async (ItemId) => {
    let formObject = {};
    let path = props.location.pathname.split('/rubus/AMM/ItemDetails/');
    let formId = ItemId ? ItemId : base64_decode(path[1]);
    if (formId !== 'new') {
      let data = await getMasterById(urlList.getbyId, formId, 'GET');
      formObject = data || {};
      _.cloneDeepWith(data, (value) => {


        return value && value.StartTime && value.EndTime
          ? {
            ...value,
            StartTime: dayjs.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss'),
            EndTime: dayjs.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss')
          }
          : _.noop();
      });
    }
    if (ItemRef.current) {
      ItemRef.current.setFieldsValue(formObject);
    }
    setFormObject(formObject);
    setDatasource(formObject?.Specifications || []);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await _getDataById();
      try {
        const response = await getDeviceList(urlList.getbyId, 'GET');
        setDeviceList(response || []);
        const value = await getManufacturerList();
        setManufacturerList(value);
      } catch (error) {
        console.error("Error fetching device list:", error);
      }
      setLoading(false);
    };
    fetchData();
  }, []);
  if (loading) {
    return;
  }



  const handleChange = async (value, key) => {
    let formObject = ItemRef.current.getFieldsValue();
    formObject = {
      ...formObject,
      [key]: value
    };
    if (key === 'DeviceId') {
      let selectedDevice = deviceList.find((item) => item.Id === value);
      if (selectedDevice) {
        let location = await getLocationByAsset(selectedDevice);
        formObject = {
          ...formObject,
          [key]: value,
          LocationId: location.data.Name
        };
      }
    }
    if (ItemRef.current) ItemRef.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };

  const fileupload = async (values, key, fileDataObject) => {
    let formObject = ItemRef.current.getFieldsValue();
    if (formObject[key]) {
      formObject[key].push(...values);
    } else {
      formObject[key] = values;
    }
    formObject[key] = formObject[key]?.reduce((acc, current) => {
      const x = acc.find((item) => item.Name === current.Name);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    formObject = {
      ...formObject,
      Specifications: datasource,
      [key]: formObject[key]
    };
    fileData.append('files', fileDataObject);
    if (ItemRef.current) ItemRef.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };

  const onFormsubmit = async (values) => {
    if (!formObject) {
      console.error('formObject is undefined');
      return;
    }

    let userId = props.userProfile?.user?.Id || '';
    let Specifications = [];
    let SpecificationsForm = formObject?.Specifications || [];
    if (SpecificationsForm && Array.isArray(SpecificationsForm)) {
      let editableList = SpecificationsForm.filter((specifi) => specifi.editable === true);
      if (editableList.length === 0) {
        Specifications = SpecificationsForm.map((spec) => {
          delete spec.editable;
          delete spec.key;
          return spec;
        });
        let payload = {
          ...formObject,
          ...values,
          ...(formObject && !formObject.Id ? { CreatedBy: userId } : {}),
          ...(formObject && formObject.Id ? { UpdatedBy: userId } : {}),
          Specifications
        };
        let statusResponse = await submitMaster(urlList.insert, payload, fileData, type);
        if (statusResponse?.message) {
          _getDataById(statusResponse.Id);
          message.success(statusResponse.message);
          props.navigate('/rubus/AMM/ItemList');
        } else if (statusResponse?.Error) {
          message.error(statusResponse.Error);
        }
      } else {
        message.warning('Please save specifications before submitting');
      }
    }
  };

  const onReset = () => {
    if (ItemRef.current) {
      ItemRef.current.resetFields();
    }
  };

  const saveTableViewData = (datasource) => {
    let formObject = ItemRef.current.getFieldsValue();
    formObject = {
      ...formObject,
      Specifications: datasource
    };
    setFormObject(formObject);
    setDatasource(datasource);
  };

  const onDrawerCancel = (e) => {
    let formObject = ItemRef.current.getFieldsValue();
    if (formObject.Equipment === undefined && e.target.tagName === 'DIV') {
      e.preventDefault();
      return message.error(`Please Click On Cancel`);
    } else {
      setVisible(false);
    }
  };

  const onModalOk = () => {
    setVisible(false);
  };

  const onManufacturerClick = (data) => {
    const testdata = ManufacturerList.filter((test) => test.Id === data);

    if (testdata.length > 0) {
      const updatedFormObject = {
        ...formObject,
        Specifications: datasource,
        ManufacturerId: testdata[0].Id,
        ManufacturerDescription: testdata[0].Description
      };

      if (ItemRef.current) {
        ItemRef.current.setFieldsValue(updatedFormObject);
      }

      setFormObject(updatedFormObject);
    }
  };

  const getDeviceData = async (key) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');

    try {
      const { data } = await axios.get(`${API_DEVICE.LIST}?SiteId=${siteId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      setTableData(data);
      setVisible((prevState) => ({
        ...prevState,
        [key]: true
      }));
      setFormObject(ItemRef.current.getFieldsValue());
    } catch (error) {
      console.error("Error fetching device data:", error);
    }
  };

  const TableDropdownChange = (value) => {
    let formObject = ItemRef.current.getFieldsValue();
    formObject = {
      ...formObject,
      Equipment: value.AliasCode,
      EquipmentDescription: value.Name,
      DeviceCode: value.DeviceCode,
      DisplayCode: value.DisplayCode
    };
    ItemRef.current.setFieldsValue(formObject);
    setFormObject(formObject);
    setVisible(false);
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, constant.search)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(translationCache, constant.search)}
        </Button>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          style={{ width: 90 }}
        >
          {translation(translationCache, constant.Reset)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  return (
    <StyledHomepageSides>
      <Form
        name="Item"
        ref={ItemRef}
        initialValues={formObject || {}}
        onFinish={onFormsubmit}
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        layout="vertical"
        validateMessages={{
          required: '${label} is required!',
          types: {
            email: '${label} is not a valid email!',
            number: '${label} is not a valid number!'
          },
          number: {
            range: '${label} must be between ${min} and ${max}'
          },
          pattern: {
            mismatch: '${label} does not match pattern'
          }
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {translation(translationCache, constant.submit)}
            </Button>
          </Form.Item>
        </div>
        <StyledBoxHeader >
          <StyledBoxLabel >
            <Typography.Title level={5}>
              {translation(translationCache, constant.itemDetails)}
            </Typography.Title>
          </StyledBoxLabel>
          <StyledBox>

            <Form.Item
              label={translation(translationCache, constant.item)}
              name="Item"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(translationCache, constant.inputItem)}
                disabled={formObject && formObject.Id ? true : false}
                onChange={(e) => handleChange(e, 'Item')}
              />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.itemDescription)}
              name="Description"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(translationCache, constant.InputDescription)}
                onChange={(e) => handleChange(e, 'Description')}
              />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.equipment)}
              name="DisplayCode"
              rules={[{ required: true }]}
            >
              <InputComponent
                disabled={true}
                suffix={
                  <DownOutlined
                    style={{
                      color: '#1a3b5c',
                      cursor: formObject && formObject.Id ? 'not-allowed' : null,
                      opacity: formObject && formObject.Id ? '0.8' : null
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      if (formObject && !formObject.Id) {
                        getDeviceData('visible');
                      }
                    }}
                  />
                }
                style={{ width: '100%' }}
                placeholder={translation(translationCache, constant.SelectEquipment)}
              />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.equipmentDescription)}
              name="EquipmentDescription"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(translationCache, constant.AutopopulatebasedonEquipment)}
                disabled={true}
              />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.issueUnit)}
              name="IssueUnit"
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(translationCache, constant.InputIssueUnit)}
                // value={'WO-11'}
                onChange={(e) => handleChange(e, 'IssueUnit')}
              />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.orderUnit)}
              name="OrderUnit"
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(translationCache, constant.InputOrderUnit)}
                onChange={(e) => handleChange(e, 'OrderUnit')}
              />
            </Form.Item>
            <Form.Item

              label={translation(translationCache, constant.itemType)}
              name="ItemType"
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(translationCache, constant.InputItemType)}
                // value={'WO-11'}
                onChange={(e) => handleChange(e, 'ItemType')}
              />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.storeLocation)}
              name="StoreLocation"
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(translationCache, constant.InputStoreLocation)}
                onChange={(e) => handleChange(e, 'StoreLocation')}
              />
            </Form.Item>
            <Form.Item

              label={translation(translationCache, constant.site)}
              name="SiteId"
              rules={[{ required: true }]}
            >
              <Select
                style={{ width: '100%' }}
                placeholder={translation(translationCache, constant.SelectSite)}
                disabled={formObject && formObject.Id ? true : false}
                onChange={(e) => handleChange(e, 'SiteId')}
              >
                {sitesList && Array.isArray(sitesList) && sitesList.map((site, index) => (
                  <Option key={index} value={site.Id}>
                    {site.Name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item

              name={'Attachments'}
              label={
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>
                    {translation(translationCache, constant.attachments)}
                    <PaperClipOutlined className="plusCircleOutlined" />
                  </span>
                </div>
              }
            >
              <FileBase64
                style={{ width: '100%' }}
                Attachments={formObject && formObject.Attachments}
                fileUpload={fileupload}
              />
            </Form.Item>
          </StyledBox>
        </StyledBoxHeader>
        <StyledBoxHeader >
          <StyledBoxLabel >
            <Typography.Title level={5}>
              {translation(translationCache, constant.material)}
            </Typography.Title>
          </StyledBoxLabel>
          <StyledBox>
            <Form.Item
              label={translation(translationCache, constant.material)}
              name="Material"
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(translationCache, constant.InputMaterial)}
                onChange={(e) => handleChange(e, 'Material')}
              />
            </Form.Item>

            <Form.Item
              label={translation(translationCache, constant.partsNameSystem)}
              name="PartsNameSystem"
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(translationCache, constant.inputPartsNameSystem)}
                onChange={(e) => handleChange(e, 'PartsNameSystem')}
              />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.manufacturer)}
              name="ManufacturerId"
            >
              <Select
                style={{ width: '100%' }}
                // value={formObject.Manufacturer}
                placeholder={translation(translationCache, constant.SelectManufacturer)}
                onChange={(e) => onManufacturerClick(e)}
              >
                {ManufacturerList && Array.isArray(ManufacturerList) && ManufacturerList.map((code, index) => (
                  <Option key={index} value={code.Id}>
                    {code.Manufacturer}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.manufacturerDescription)}
              name="ManufacturerDescription"
              rules={[{ required: false }]}
            >
              <InputComponent
                style={{ width: '100%' }}
                placeholder={translation(translationCache, constant.AutopopulatebasedonManufacturer)}
                disabled={true}
              />
            </Form.Item>
            <Form.Item

              label={translation(translationCache, constant.Quantity)}
              name="AvailableQuantity"
              rules={[
                { required: true },
                {
                  validator: (_, value) => check(value, 'Item', { validateDecimal: true })
                }
              ]}
            >
              <InputNumberComponent
                style={{ width: '100%' }}
                placeholder={translation(translationCache, constant.InputQuantity)}
                onChange={(e) => handleChange(e, 'AvailableQuantity')}
              />
            </Form.Item>

            <Form.Item name="Equipment"></Form.Item>
            <Form.Item name="Id"></Form.Item>
          </StyledBox>
        </StyledBoxHeader>
       <StyledBoxLabel >
            <Typography.Title level={5}>
              {translation(translationCache, constant.specifications)}
            </Typography.Title>
          </StyledBoxLabel>

        <Form.Item>
          <TableView
            form={{ columns: columns, datasource }}
            recordType={'FormSubSectionTable'}
            saveTableViewData={(e) => saveTableViewData(e)}
            showAddButton={true}
          />
        </Form.Item>
      </Form>
      <Modal
        open={visible}
        width={800}
        closable
        title={translation(translationCache, constant.selectEquipment)}
        onOk={onModalOk}
        onCancel={onDrawerCancel}
      >
        <TableSelect
          data={tableData}
          translationCache={props.translationCache}
          key="Equipment"
          columns={[
            {
              title: translation(translationCache, 'Equipment'),
              dataIndex: 'DisplayCode',
              key: 'DisplayCode',
              ...getColumnSearchProps('DisplayCode')
            },
            {
              title: translation(translationCache, 'Equipment Description'),
              dataIndex: 'Name',
              key: 'Name',
              ...getColumnSearchProps('Name')
            }
          ]}
          handleDropdownChange={(e) => TableDropdownChange(e, 'visible')}
        />
      </Modal>
    </StyledHomepageSides>
  );
};

const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    userProfile: state.LayoutReducer.userProfile
  };
};

export default connect(mapStateToProps)(ItemDetails);